import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Stack, Table, TableHead, TableRow, TableCell, TableBody,
  Alert, CircularProgress, Chip,
} from '@mui/material'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { getPickingList, confirmPickingList } from '../../api/logistica'
import { errorMessage } from '../../api/client'

export default function PickingListDetailDialog({ id, onClose }: { id: string | null; onClose: () => void }) {
  const open = id !== null
  const qc = useQueryClient()
  const { data } = useQuery({ queryKey: ['logistica', 'picking', id], queryFn: () => getPickingList(id!), enabled: open })

  const confirmMutation = useMutation({
    mutationFn: () => confirmPickingList(id!),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['logistica', 'picking'] })
    },
  })

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        Listă de picking {data?.number} — {data?.orderNumber} ({data?.clientName})
        {data && <Chip size="small" sx={{ ml: 1.5 }} label={data.status === 'Draft' ? 'Ciornă' : 'Confirmată'} color={data.status === 'Draft' ? 'default' : 'success'} />}
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Articol</TableCell><TableCell>Depozit</TableCell><TableCell>Zonă/Locație</TableCell>
                <TableCell>Lot</TableCell><TableCell align="right">Cantitate</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.lines.map((l) => (
                <TableRow key={l.id}>
                  <TableCell>{l.articleCode} — {l.articleDescription}</TableCell>
                  <TableCell>{l.warehouseName}</TableCell>
                  <TableCell>{l.zoneName ?? '—'} {l.locationCode ? `/ ${l.locationCode}` : ''}</TableCell>
                  <TableCell>{l.lotNumber ?? '—'}</TableCell>
                  <TableCell align="right">{l.quantity}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          {confirmMutation.isError && <Alert severity="error">{errorMessage(confirmMutation.error)}</Alert>}
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5 }}>
        <Button onClick={onClose}>Închide</Button>
        {data?.status === 'Draft' && (
          <Button variant="contained" disabled={confirmMutation.isPending} onClick={() => confirmMutation.mutate()}
            startIcon={confirmMutation.isPending ? <CircularProgress size={16} color="inherit" /> : undefined}>
            Confirmă
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )
}
